import React, { Component, Fragment } from 'react';
import { List } from 'semantic-ui-react'
import { Dropdown, Icon } from 'semantic-ui-react'
import { connect } from 'react-redux';
import moment from 'moment'

import { CREATE_CONTROLS } from '../../constants';
import RisksControlAction from "../../actions/v2/risks/control"
import { createControl, updateControl, deleteControl, createControlFailure, updateControlFailure, deleteControlFailure } from '../../actions/control'
import { updateTags } from '../../actions/tags'
import * as libraryControlActions from '../../actions/library_control'
import CreateControlModal from './create_control_modal'
import LibraryControlItem from './library_control_item'
import DefaultControlsDeletedModal from '../../views/default_controls_deleted_logs/default_controls_deleted_modal';
import { fetchRemovedDefaultTemplateControls } from '../../services/risksService';
import { getText } from '../../helpers';

import 'semantic-ui-css/semantic.min.css';
import '../../App.css';
import './index.css';

class ControlsComponent extends Component {
  constructor(props){
    super(props);
    this.state = {
      controls: props.value,
      riskId: props.riskId,
      controlIndex: 0,
      tagOptions: props.TagOptions,
      translations: props.translations,
      controlId: null,
      showStaticDetails: true,
      action: null,
      enable_cts_access: props.instanceConfig.enable_cts_access,
      newControlId: null,
      createControlShown: false,
      control: { type: "library" },
      libraryControls: [],
      deletedDefaultControlModalShown: false,
      deletedDefaultControls: {},
      deletedControlsCount: null,
    }

    this.translatedTagsOptions = this.getTranslatedTagsOptions()
    this.parseTags()
  }

  componentDidMount = () => {
    !this.props.skipFetchingDeletedControlNotes && this.refreshDeletedDefaultTemplateControls(this.props.riskId);
    this.addTabIndecesToControls();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.riskId !== this.props.riskId) {
    this.setState({ deletedControlsCount: 0 }); 
    !this.props.skipFetchingDeletedControlNotes && this.fetchDeletedDefaultTemplateControls(this.props.riskId);
    }
    this.addTabIndecesToControls();

    if (prevProps.value !== this.props.value) {
      this.setState({ controls: this.props.value })
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.actionRiskId === this.state.riskId ){
      if (nextProps.createSuccess){
        if(nextProps.controlType !== nextProps.control.control_type) {
          return
        }
        var found = this.state.controls.some((el) => {
          return el.id === nextProps.control.id;
        });
        if (!found) {
          var controls = this.state.controls.splice(this.state.controlIndex, 1, nextProps.control);
          this.setState({
            conrols: controls,
            controlId: nextProps.control.id
          })
        }
        this.props.resetCreateControl();
      }
      else if(nextProps.createControlsSuccess) {
        let newControls = nextProps.controls

        if(!newControls || nextProps.controlType !== newControls[0].control_type) {
          return
        }

        // remove duplicate controls
        const controlsIds = this.state.controls.map(({ id }) => id);
        newControls = newControls.filter((control) => !controlsIds.includes(control.id));

        const controls = this.state.controls.concat(newControls)
    
        this.setState({ controls })
        this.props.resetCreateControls();
      }
      else if (nextProps.updateSuccess) {
        this.props.resetUpdateControl();
      }
      else if (nextProps.deleteSuccess) {
        this.refreshDeletedDefaultTemplateControls(this.props.riskId);
        this.props.resetDeleteControl();
      }
    }

    if (this.props.translations !== nextProps.translations){
      this.setState({
        translations: nextProps.translations
      }, ()=>{
        this.translatedTagsOptions = this.getTranslatedTagsOptions()
        this.parseTags()
      })
    }

    this.showTagsDropdown(this.state.controlId)
  }

  getTranslatedTagsOptions = () => {
    const { admin, critical, elim, eng_ing, sub, ppe_epp } = this.state.translations
    return {
      'Admin'       : admin,
      'Critical'    : critical,
      'Eliminate'   : elim,
      'Engineering' : eng_ing,
      'Substitution': sub,
      'PPE'         : ppe_epp
    }
  }

  filterDeletedControls = (controls, controlType) => {
    if (!controls || !Array.isArray(controls)) {
      return [];
    }

    return controls.filter(ctrl => {
      if (!ctrl.control || !ctrl.control.control_type) return false;
      return ctrl.control.control_type.toLowerCase() === (controlType || '').toLowerCase();
    });
  }


  fetchDeletedDefaultTemplateControls = (riskId) => {
    if (!riskId) return;
    fetchRemovedDefaultTemplateControls(riskId)
      .then((deletedDefaultControlsRecords) => {
        const records = Array.isArray(deletedDefaultControlsRecords) ? deletedDefaultControlsRecords : [];
        const currentCount = this.filterDeletedControls(records, this.props.controlType).length;

        this.setState(prevState => ({
          deletedDefaultControls: {
            ...prevState.deletedDefaultControls,
            [riskId]: records
          },
          deletedControlsCount: currentCount
        }));
      })
      .catch((err) => {
        console.error("Error fetching deleted controls", riskId, err);
      });
  };

  addTabIndecesToControls = () => {
    for (var i in this.state.controls){
      let control = this.state.controls[i];
      if (control.id && !control.is_library_control) {
        var element = document.getElementById(control.id.toString())
        if (element){
          element.setAttribute('tabindex',control.id.toString())
        }
      }
    }
  }

  removeTagsFromName = (name) => {
    return name.replace(/(#[a-zA-Z]*)/g, "")
  }

  parseTags = () => {
    if (!this.props.isRiskHidden){
      for (var i in this.state.controls){
        var control = this.state.controls[i];
        for (var j in control.tag_list){
          var tag = {
            key: control.tag_list[j],
            value: control.tag_list[j],
            text: this.translatedTagsOptions[control.tag_list[j]]
          }
          this.props.setTagOptions(tag)
        }
      }
    }
  }

  selectControlText = (containerid) => {
    var range;
    if (document.selection) { // IE
      range = document.body.createTextRange();
      range.moveToElementText(document.getElementById(containerid));
      range.select();
    } else if (window.getSelection) {
      range = document.createRange();
      range.selectNode(document.getElementById(containerid));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
    }
  }

  focusControl = (id) => {
    if(id){
      var control_element = document.getElementById('control-'+id)
      if (control_element) {
        control_element.setAttribute('tabindex','control-'+id)
        control_element.focus();
        this.selectControlText('control-'+id)
      }
    }
  }

  selectElementContents = (el) => {
    var range = document.createRange();
    range.selectNodeContents(el);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  }

  copyControl = (evt, id) => {
    this.selectAndCopyToClipboard(id);
    localStorage.setItem('control_copy', this.getControlValue(id));
  }

  selectAndCopyToClipboard = (id) => {
    this.selectControlText('control-'+id);
    document.execCommand("copy");
  }

  pasteControl = (evt, id) => {
    var control = document.getElementById('control-'+id)
    control.focus()
    control.value = localStorage.getItem('control_copy');
  }

  controlsKeyUp = (evt, object) => {
    var keycode = (evt.keyCode ? evt.keyCode : evt.which);
    if(keycode === '13' && evt.altKey){
      object.addControl(object.state.controlIndex + 1)
    }
  }

  addControl = (index) => {
    var new_control = {
      id: 0,
      name: '',
      tag_list: [],
      cts_metadata: null,
      control_type: this.props.controlType
    }
    var controls = [...this.state.controls]
    controls.splice(this.state.controlIndex, 0, new_control);
    this.setState({
      controlIndex: index,
      controls: controls,
      controlId: 0,
      control: new_control,
      showStaticDetails: false,
      action: 'create'
    })
    const control_details = {
      plan_id: this.props.planId,
      risk_id: this.props.riskId,
      name: '',
      tag_list: [],
      cts_metadata: null,
      control_type: this.props.controlType,
    }
    this.props.createControl(control_details);
  }


  deleteControl = (index) => {
    var control = this.state.controls[index];
    this.props.deleteControl(this.props.planId, this.props.riskId, control)
    var controls = this.state.controls.splice(index, 1);
    this.setState({
      conrols: controls
    }, this.refreshDeletedDefaultTemplateControls)
  }

  refreshDeletedDefaultTemplateControls = () => {
    this.fetchDeletedDefaultTemplateControls(this.props.riskId);
  }

  updateTags = (evt, data, control_id) => {
    for (var i in data.value){
      var tag = {
        key: data.value[i],
        value: data.value[i],
        text: this.translatedTagsOptions[data.value[i]]
      }
      this.props.setTagOptions(tag)
    }
    this.props.updateTags(this.props.planId, this.props.riskId, control_id, data.value.join(', '));
  }

  toggleDetailsPopup = (evt, id) => {
    evt.stopPropagation();

    var el = document.getElementById("control-details-" + id)
    if (el.style.display === 'block'){
      el.style.display = 'none';
    }
    else {
      el.style.display = 'block';
      el.style.marginBottom= '10px'
    }
  }

  toggleTagsDropdown = (id) => {
    var dropdownElement = document.getElementById('drop'+id)
    if (!dropdownElement) return;
  
    if (dropdownElement.style.display === 'block'){
      dropdownElement.style.display = 'none';
    }
    else {
      dropdownElement.style.display = 'block';
      dropdownElement.style.marginBottom= '10px'
    }
  }

  showTagsDropdown = (id) => {
    var dropdownElement = document.getElementById('drop'+id)
    if (dropdownElement) {
      dropdownElement.style.display = 'block';
      dropdownElement.style.marginBottom= '10px';
    }
  }

  renderDefinitions = (referenceId) => {
    const { definitions, last_verifier, verifier, risk_owner, owner, verifier_response_description, risk_owner_response_description } = this.state.translations
    return (
      <div ref={referenceId} className="definitions-modal">
        <div className="definitions-header">
          <h4>{definitions}</h4>
        </div>
        <div className="definitions-content">
          <div><b>{last_verifier} ({verifier})</b> - {verifier_response_description}</div>
          <div><b>{risk_owner} ({owner})</b> - {risk_owner_response_description}</div>
        </div>          
      </div>
    )
  }

  toggleDefinitions = (evt, referenceId) => {
    evt.stopPropagation()
    var definitions_modal = this.refs[referenceId]
    definitions_modal.classList.toggle("show")
  }

  toggleDeletedDefaultControlsModal = () => {
    this.setState({ deletedDefaultControlModalShown: !this.state.deletedDefaultControlModalShown });
  }

  cvsDetailsRenderer = (control) => {
    const { not_available, control_status, request, response, no_cvs_info_entered, owner, verifier } = this.state.translations
    var definitions_modal_id = "definitions-modal-"+control.id
    var response_date, request_date, response_status, status_logic
    if (control.cts_metadata){
      response_date = control.cts_metadata.response_date
      response_date = response_date && response_date.length > 0 ? moment(control.cts_metadata.response_date).format("DD MMM YYYY") : not_available
      request_date = control.cts_metadata.request_date
      request_date = request_date && request_date.length > 0 ? moment(control.cts_metadata.request_date).format("DD MMM YYYY") : not_available
      response_status = control.cts_metadata.response_status
      status_logic = control.cts_metadata.status_logic
    }

    return (<span className="control-details" style={{paddingBottom: 3}}>
      <div className={"circle-icon " + response_status} title={control_status} onClick={(evt)=>this.toggleDetailsPopup(evt, control.id)}>C</div>
      <div id={"control-details-" + control.id} className="control-details-modal" onMouseLeave={(evt)=>this.toggleDetailsPopup(evt, control.id)}>
        <div className="control-details-modal-content">
          <div className="control-details-modal-close" onClick={(evt)=>this.toggleDetailsPopup(evt, control.id)}>&times;</div>
          { control.cts_metadata
            ?
            <div>
              <div>
                <div>
                  <div className={"circle-icon " + control.cts_metadata.response_status} title={control_status}>C</div>
                  <span className="control-details-responsible-person">
                    {control.cts_metadata.verifier}
                  </span>
                </div>
                <div style={{marginTop: '5px'}}>
                  { status_logic === 'risk_owner' ? <i class="text-small-grey">{owner} </i> : <i class="text-small-grey">{verifier} </i> }
                  <span 
                    class="text-light-blue" 
                    onMouseEnter={evt=>this.toggleDefinitions(evt,definitions_modal_id)}
                    onMouseLeave={evt=>this.toggleDefinitions(evt,definitions_modal_id)}
                  ><Icon name="question circle"/></span>
                  {this.renderDefinitions(definitions_modal_id)}
                </div>
              </div>
              <hr className="control-details-hr"/>
              <span ><label>{request}:</label> {request_date}</span><br/>
              <span ><label>{response}:</label> {response_date}</span><br/>
              <p className="control-subdetails text-left"><label>ID:</label> {control.cts_metadata.id}</p>
            </div>
            : <p>{no_cvs_info_entered}</p>
          }
        </div>
      </div>
    </span>)
  }

  showControlTextarea = (control, index) => {
    if(!this.props.permission.can_update) return

    this.showTagsDropdown(control.id)
    this.setState({
      controlIndex: index,
      origControlValue: control.name,
      showStaticDetails: false,
      controlId: control.id,
      action: 'update'
    })
  }

  saveControl = (evt) => {
    const { action, origControlValue, controls} = this.state
    const showStaticDetails = evt.type === 'mouseleave' ? true : false

    if (!action) {
      this.setState({
        showStaticDetails: showStaticDetails,
        controlIndex: 0
      })
      return
    }

    const control_id = parseInt(evt.currentTarget.dataset.controlId, 10)
    const control_index = parseInt(evt.currentTarget.dataset.controlIndex, 10)
    const new_control_value = this.getControlValue(control_id)

    if (!new_control_value) {
      if (action==='create'){
        controls.splice(control_index, 1);
      }
      this.setState({
        controls: controls,
        showStaticDetails: showStaticDetails,
        action: null,
        controlIndex: 0
      })
      return
    }

    if (new_control_value.trim().length === 0 || new_control_value === origControlValue){
      this.setState({
        showStaticDetails: showStaticDetails,
        controlIndex: 0
      })
      return
    }

    var sliced_controls = controls.slice();
    var control = sliced_controls[control_index];
    control.name = new_control_value;
    this.setState({
      controls: sliced_controls,
      showStaticDetails: showStaticDetails,
      action: null
    });

    if (action === 'create'){
      control.plan_id = this.props.planId;
      control.risk_id = this.props.riskId;
      this.props.createControl(control);
    }
    if (action === 'update'){
      this.props.updateControl(this.props.planId, this.props.riskId, control);
    }
    
  }

  getControlValue = (control_id) => {
    const control_element = document.getElementById('control-'+control_id)
    let control_value
    if (control_element){
      control_value = control_element.value.replace(/\n/g," ")
    }
    return control_value
  }

  listItemRenderer = (control, index) => {
    var dropdown_style = { display: 'block' }
    if (control.tag_list.length === 0){
      dropdown_style = { display: 'none' }
    }
    const { toggle_tags_tip, tags, copy, copy_tip, paste, paste_tip, delete_control_tip, add_a_tag} = this.state.translations
    const can_update = this.props.permission.can_update

    var showStaticDetails = true
    if (this.state.controlId === control.id){
      showStaticDetails = this.state.showStaticDetails
    }

    return (
      <div className="controls-renderer" data-control-id={control.id} data-control-index={index} onMouseLeave={this.saveControl}>
        {
          showStaticDetails &&
          <div className="control-static-details" id={control.id}>
            <span onClick={(evt)=>this.showControlTextarea(control, index)}>{control.name ? this.removeTagsFromName(control.name) : ""}</span>
            &nbsp;
            {
              this.props.permission.can_update &&
              <i className="delete icon delete-control"
                onClick={()=>this.deleteControl(index)}
                title={delete_control_tip}>
              </i>
            }
            {
              this.state.enable_cts_access && this.cvsDetailsRenderer(control)
            }
          </div>
        }
        {
          !showStaticDetails &&
          <div id={control.id} className="control-edit-details">
            <div id={"control-toolbar-" + control.id} className="control-toolbar">
              <i className="tag icon"
                onClick={(evt)=>this.toggleTagsDropdown(control.id)}
                title={toggle_tags_tip}>
                <span> {tags}</span>
              </i>
              <i className="copy icon"
                onClick={(evt)=>this.copyControl(evt, control.id)}
                title={copy_tip}>
                <span> {copy}</span>
              </i>
              <i className="paste icon"
                onClick={(evt)=>this.pasteControl(evt, control.id, index)}
                title={paste_tip}>
                <span> {paste}</span>
              </i>
            </div>
            <textarea id={"control-" +control.id} data-control-id={control.id} data-control-index={index} onBlur={this.saveControl} defaultValue={control.name}></textarea>
          </div>
        }
        
        <Dropdown
          id={"drop" + control.id}
          ref={"drop" + control.id}
          style={dropdown_style}
          className={ can_update ?  "control-dropdown" : "control-dropdown readonly" }
          placeholder={add_a_tag}
          fluid
          multiple
          search
          selection
          options={this.state.tagOptions}
          defaultValue={control.tag_list}
          onChange={(evt, data)=>this.updateTags(evt, data, control.id)}
          closeOnBlur={true}
          closeOnChange={true}
          disabled={!this.props.permission.can_update}
          >
        </Dropdown>

      </div>
    )
  }

  showCreateControl = () => {
    this.setState({
      createControlShown: true
    })
  }

  hideCreateControl = () => {
    this.setState({
      createControlShown: false
    })
  }

  createLibraryControl = (libraryControl) => {
    const { controls } = this.state;
    this.hasBeenFocused = false
    this.setState({
      controlIndex: controls.length, createControlShown: false
    })

    const control_details = {
      plan_id: this.props.planId,
      risk_id: this.props.riskId,
      control_type: this.props.controlType,
      name: libraryControl.title,
      library_control_id: libraryControl.id
    }
    this.props.createControl(control_details);
  }

  createLibraryControls = (libraryControls) => {
    const { controls } = this.state;
    this.hasBeenFocused = false
    this.setState({
      controlIndex: controls.length, createControlShown: false
    })

    const libraryControlList = libraryControls.map((libraryControl) => ({
      control_type: this.props.controlType,
      name: libraryControl.title,
      library_control_id: libraryControl.id
    }))

    const control_data = {
      plan_id: this.props.planId,
      risk_id: this.props.riskId,
      controls: libraryControlList
    }
    this.props.createControls(control_data);
  }

  createCustomControl = (control) => {
    const { controls } = this.state;
    this.hasBeenFocused = false
    this.setState({
      controlIndex: controls.length, createControlShown: false
    })

    const control_details = {
      plan_id: this.props.planId,
      risk_id: this.props.riskId,
      control_type: this.props.controlType,
      name: control.name,
      is_library_control: false
    }
    this.props.createControl(control_details);
  }

  render() {
    const { permission } = this.props;
    const showDeleteButton = permission && permission.can_update;

    const { controls, createControlShown } = this.state;
    const { new_control } = this.state.translations
    const controlItems = controls.map((control, index) => {
      const libraryControlItemProps = {
        control: control.library_control,
        index: index,
        deleteControl: this.deleteControl,
        showTranslationModal: this.props.showTranslationModal
      }
      return (
        <List.Item
          key={control.id}
          content={
            control.library_control_id ? <LibraryControlItem {...libraryControlItemProps} showDeleteButton={showDeleteButton}/> : this.listItemRenderer(control, index)
          }>
        </List.Item>
      )
    })

    const { controlType } = this.props;
    const deletedControlsForThisRisk = this.state.deletedDefaultControls[this.props.riskId] || [];
    const filteredDeletedControls = this.filterDeletedControls(deletedControlsForThisRisk, controlType);
    const defaultControlsDeletedLength = filteredDeletedControls.length;

    return (
      <div className="controls-list">
        { this.props.permission.can_update && <a className="add-control" onClick={() => this.showCreateControl()}><i className="plus icon"></i>{new_control}</a>}
        { this.state.deletedControlsCount > 0 && (
          <React.Fragment>
            <div className="control-logs-button" onClick={this.toggleDeletedDefaultControlsModal}>
              <a id="control-logs-button-text">{getText("Default Controls Removed")}</a>
            </div>
            {this.state.deletedDefaultControlModalShown && (
              <DefaultControlsDeletedModal 
                controlType={controlType}
                planId={this.props.planId}
                deletedDefaultControls={filteredDeletedControls}
                onClose={this.toggleDeletedDefaultControlsModal}
                workPhaseOrAmbientExposure={this.props.work_phase_or_ambient_exposure}
                activity={this.props.activity}
                hazard={this.props.hazard}
                unwantedEvent={this.props.unwanted_event}
              />
            )}
          </React.Fragment>
        )}
        <List bulleted>
          { controlItems }
        </List>
        {
          createControlShown && 
          <CreateControlModal
            createLibraryControls={this.createLibraryControls}
            createCustomControl={this.createCustomControl}
            hideCreateControl={this.hideCreateControl}
          />
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    control: state.control.control,
    controls: state.control.controls,
    pending: state.control.pending,
    createSuccess: state.control.createSuccess,
    createControlsSuccess: state.control.createControlsSuccess,
    updateSuccess: state.control.updateSuccess,
    deleteSuccess: state.control.deleteSuccess,
    actionRiskId: state.control.riskId,
    updateTagsSuccess: state.tags.updateSuccess,
    tags: state.tags.tagList,
    instanceConfig: state.instance.instanceConfig,
  }
}

const mapDispatchToProps = (dispatch) => {
  const riskControlAction = new RisksControlAction();

  return {
    createControl: (control_details) => {
      dispatch(createControl(control_details))
    },
    createControls: (control_list) => {
      dispatch(riskControlAction.createControls(control_list))
    },
    updateControl: (plan_id, risk_id, control) => {
      dispatch(updateControl(plan_id, risk_id, control))
    },
    deleteControl: (plan_id, risk_id, control) => {
      dispatch(deleteControl(plan_id, risk_id, control))
    },
    updateTags: (plan_id, risk_id, control_id, tag_list) => {
      dispatch(updateTags(plan_id, risk_id, control_id, tag_list))
    },
    resetCreateControl: () => {
      dispatch(createControlFailure());
    },
    resetCreateControls: () => {
      dispatch(riskControlAction.failureDispatch(CREATE_CONTROLS));
    },
    resetUpdateControl: () => {
      dispatch(updateControlFailure());
    },
    resetDeleteControl: () => {
      dispatch(deleteControlFailure());
    },
    showTranslationModal: (translation_id) => {
      dispatch(libraryControlActions.showTranslationModal(translation_id))
    },
  }
}

let ControlsComponentView = connect(mapStateToProps, mapDispatchToProps)(ControlsComponent)
export default ControlsComponentView;



// WEBPACK FOOTER //
// ./src/components/controls_component/index.js